<template>
  <div>
    <!-- Header Section -->
    <div class="dashboard-header">
      <div class="header-content">
        <h1 class="dashboard-title">ระบบแจ้งเตือนการสมัครและย้าย</h1>
        <p class="dashboard-subtitle">ติดตามสถานะและกำหนดการที่สำคัญ</p>
      </div>
    </div>

    <!-- Summary Cards -->
    <div class="">
      <v-row>
        <v-col cols="12" md="6">
          <v-card class="summary-card active-card" @click="activeApplicationsDialog = true" style="cursor: pointer;">
            <v-card-text>
              <div class="summary-content">
                <div class="summary-icon active-icon">
                  <v-icon color="white" size="30">mdi-account-clock</v-icon>
                </div>
                <div class="summary-info">
                  <p class="summary-title">การสมัครที่เปิดอยู่</p>
                  <h2 class="summary-value">{{ activeApplications.length }}</h2>
                  <p class="summary-subtitle">คลิกเพื่อดูรายละเอียด</p>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        
        <v-col cols="12" md="6">
          <v-card class="summary-card urgent-card" @click="urgentDeadlinesDialog = true" style="cursor: pointer;">
            <v-card-text>
              <div class="summary-content">
                <div class="summary-icon urgent-icon">
                  <v-icon color="white" size="30">mdi-alert-circle</v-icon>
                </div>
                <div class="summary-info">
                  <p class="summary-title">ใกล้ปิดรับสมัคร</p>
                  <h2 class="summary-value">{{ urgentDeadlinesList.length }}</h2>
                  <p class="summary-subtitle">คลิกเพื่อดูรายละเอียด</p>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>       
     
      </v-row>
    </div>

    <!-- Alert Section -->
    <div>
   
         <!-- สำรวจใบอนุญาตประกอบวิชาชีพเฉพาะ -->
      <v-hover v-slot="{ hover }">
        <v-card
          :elevation="hover ? 20 : 4"
          :class="{ 'on-hover': hover }"
          class="alert-card mb-6"
          v-if="
            periodTeacherAssistant.period_enable==='1' && users.position_name === 'ครูผู้ช่วย'"
        >
          <div class="alert-stripe urgent-stripe"></div>
          <v-card-text class="alert-content pa-6">
            <v-row align="center">
              <v-col cols="12" lg="7">
                <div class="alert-header">
                  <v-icon color="primary" size="40" class="mr-3">mdi-account-star</v-icon>
                  <div>
                    <h2 class="alert-title">
                      เปิดระบบสำรวจใบอนุญาตประกอบวิชาชีพเฉพาะ (ที่ไม่ใช่ใบอนุญาตประกอบวิชาชีพครู หรือ ผู้บริหาร)
                    </h2>
                    <p class="alert-description">
                      สามารถดำเนินการสมัครก่อนระบบปิดในวันที่
                      <strong class="deadline-text">
                        {{
                          periodTeacherAssistant.period_stop
                            | moment("add", "543 years")
                            | moment("D MMMM YYYY")
                        }}
                      </strong>
                    </p>
                  </div>
                </div>  
              </v-col>
              
              <v-col cols="12" lg="5">
                <div class="alert-actions">
                  <div class="action-buttons">
                    <v-btn                     
                      color="primary"
                      x-large
                      rounded
                      to="/servey_assistant_specialized_licenses"
                      class="action-btn"
                    >
                      <v-icon left>mdi-account-plus</v-icon>
                      ดำเนินการ
                    </v-btn>                   
                  
                  </div>
                  
                  <div class="countdown-timer mt-4">
                    <div class="text-center">
                      <p class="deadline-text mb-2">
                        เหลือเวลาอีก
                      </p>
                      <flip-countdown
                        :deadline="
                          periodTeacherAssistant.period_stop + ' 16:30:00'
                        "
                        :labels="labels"
                      ></flip-countdown>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-hover>


      <!-- แจ้งสอบผู้อำนวยการ -->
      <v-hover v-slot="{ hover }">
        <v-card
          :elevation="hover ? 20 : 4"
          :class="{ 'on-hover': hover }"
          class="alert-card mb-6"
          v-if="
            period_directors.period_sedirector_enable === '1' &&
              (users.user_status === 'se_director' ||
                users.user_status === 'S' ||
                users.user_status === 'C')
          "
        >
          <div class="alert-stripe urgent-stripe"></div>
          <v-card-text class="alert-content pa-6">
            <v-row align="center">
              <v-col cols="12" lg="7">
                <div class="alert-header">
                  <v-icon color="primary" size="40" class="mr-3">mdi-account-star</v-icon>
                  <div>
                    <h2 class="alert-title">
                      เปิดระบบการรับสมัครคัดเลือกตำแหน่ง ผู้อำนวยการวิทยาลัย
                    </h2>
                    <p class="alert-description">
                      สามารถดำเนินการสมัครก่อนระบบปิดในวันที่
                      <strong class="deadline-text">
                        {{
                          period_directors.period_sedirector_stop
                            | moment("add", "543 years")
                            | moment("D MMMM YYYY")
                        }}
                      </strong>
                    </p>
                  </div>
                </div>
                
                <!-- Application Status Cards -->
                <div class="mt-4">
                  <v-card
                    v-if="director_apps.sedirector_app_pvc_approve === 'pass'"
                    class="status-card success-stripe mb-3"
                    outlined
                  >
                    <v-card-text class="pa-4">
                      <div class="flex-between">
                        <div>
                          <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
                          <strong>ผ่านการตรวจสอบคุณสมบัติเบื้องต้นจาก สอจ.</strong>
                        </div>
                        <v-btn color="success" outlined rounded to="/director_app" class="action-btn">
                          <v-icon left>mdi-eye</v-icon>
                          ตรวจสอบ
                        </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card
                    v-if="director_apps.sedirector_app_ipacheck === 'pass'"
                    class="status-card info-stripe mb-3"
                    outlined
                  >
                    <v-card-text class="pa-4">
                      <div class="flex-between">
                        <div>
                          <v-icon color="info" class="mr-2">mdi-check-circle</v-icon>
                          <strong>การตรวจสอบเอกสารจาก ส่วนกลาง กจ.2</strong>
                          <p class="mb-0 mt-1 text-muted">{{ director_apps.sedirector_app_ipacheckcomment }}</p>
                        </div>
                        <v-btn color="info" outlined rounded to="/director_app" class="action-btn">
                          <v-icon left>mdi-eye</v-icon>
                          ตรวจสอบ
                        </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card
                    v-if="director_apps.sedirector_app_ipacheck === 'notpass'"
                    class="status-card error-stripe mb-3"
                    outlined
                  >
                    <v-card-text class="pa-4">
                      <div class="flex-between">
                        <div>
                          <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
                          <strong>แจ้งเตือนการสมัคร</strong>
                          <p class="mb-0 mt-1 text-error">{{ director_apps.sedirector_app_ipacheckcomment }}</p>
                        </div>
                        <v-btn color="warning" outlined rounded to="/director_app" class="action-btn">
                          <v-icon left>mdi-pencil</v-icon>
                          ตรวจสอบ/แก้ไข
                        </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>
              
              <v-col cols="12" lg="5">
                <div class="alert-actions">
                  <div class="action-buttons">
                    <v-btn
                      v-if="
                        users.user_status === 'se_director' ||                          
                          users.user_status === 'S' ||
                          users.user_status === 'C'
                      "
                      color="primary"
                      x-large
                      rounded
                      to="/director_app"
                      class="action-btn"
                    >
                      <v-icon left>mdi-account-plus</v-icon>
                      สมัครตำแหน่ง
                    </v-btn>
                    
                    <v-btn 
                      icon
                      color="red"
                      @click="VideoDialog()"
                      class="video-btn"
                    >
                      <v-icon>mdi-play-circle</v-icon>
                    </v-btn>
                  </div>
                  
                  <div class="countdown-timer mt-4">
                    <div class="text-center">
                      <p class="deadline-text mb-2">
                        เหลือเวลาอีก
                      </p>
                      <flip-countdown
                        :deadline="
                          period_directors.period_sedirector_stop + ' 16:30:00'
                        "
                        :labels="labels"
                      ></flip-countdown>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-hover>

      <!-- แจ้งสอบรองผู้อำนวยการ -->
      <v-hover v-slot="{ hover }">
        <v-card
          :elevation="hover ? 20 : 4"
          :class="{ 'on-hover': hover }"
          class="alert-card mb-6"
          v-if="
            period_sedirectors.period_sedirector_enable === '1' &&
              (users.user_status === 'teacher' || users.user_status === 'S')
          "
        >
          <div class="alert-stripe info-stripe"></div>
          <v-card-text class="alert-content pa-6">
            <v-row align="center">
              <v-col cols="12" lg="7">
                <div class="alert-header">
                  <v-icon color="info" size="40" class="mr-3">mdi-account-tie</v-icon>
                  <div>
                    <h2 class="alert-title">
                      เปิดระบบแนบไฟล์ การรับสมัครตำแหน่ง รองผู้อำนวยการวิทยาลัย
                    </h2>
                    <p class="alert-description">
                      สามารถดำเนินการสมัครก่อนระบบปิดในวันที่
                      <strong class="deadline-text">
                        {{
                          period_sedirectors.period_sedirector_stop
                            | moment("add", "543 years")
                            | moment("D MMMM YYYY")
                        }}
                      </strong>
                    </p>
                  </div>
                </div>
              </v-col>
              
              <v-col cols="12" lg="5">
                <div class="alert-actions">
                  <div class="action-buttons">
                    <v-btn
                      v-if="
                        users.user_status === 'teacher' ||
                          users.user_status === 'S'
                      "
                      color="info"
                      x-large
                      rounded
                      to="/sedirector_app"
                      class="action-btn"
                    >
                      <v-icon left>mdi-account-plus</v-icon>
                      สมัครตำแหน่ง
                    </v-btn>
                  </div>
                  
                  <div class="countdown-timer mt-4">
                    <div class="text-center">
                      <p class="deadline-text mb-2">
                        เหลือเวลาอีก
                      </p>
                      <flip-countdown
                        :deadline="
                          period_sedirectors.period_sedirector_stop + ' 16:30:00'
                        "
                        :labels="labels"
                      ></flip-countdown>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-hover>

      <!-- พนักงานราชการ -->
      <v-hover v-slot="{ hover }">
        <v-card
          :elevation="hover ? 20 : 4"
          :class="{ 'on-hover': hover }"
          class="alert-card mb-6"
          v-if="
            periods_govem.period_enable === '1' && users.user_status === 'gov_em'
          "
        >
          <div class="alert-stripe warning-stripe"></div>
          <v-card-text class="alert-content pa-6">
            <v-row align="center">
              <v-col cols="12" lg="7">
                <div class="alert-header">
                  <v-icon color="orange" size="40" class="mr-3">mdi-account-group</v-icon>
                  <div>
                    <h2 class="alert-title">พนักงานราชการ</h2>
                    <p class="alert-description">
                      สามารถดำเนินการ <strong>ยื่นคำร้องขอย้าย</strong> ก่อนระบบปิดในวันที่
                      <strong class="deadline-text">
                        {{
                          periods_govem.period_stop
                            | moment("add", "543 years")
                            | moment("D MMMM YYYY")
                        }}
                      </strong>
                    </p>
                  </div>
                </div>
              </v-col>
              
              <v-col cols="12" lg="5">
                <div class="alert-actions">
                  <div class="action-buttons" v-if="users.date_app_now !== ''">
                    <v-btn
                      v-if="
                        periods_govem.period_enable === '1' &&
                          users.user_status === 'gov_em' &&
                          periods_govem.period_type === 'gov_em' &&
                          !(users.type_personnel === 'gov_em' && get_gov_Age_year < 1)
                      "
                      color="orange"
                      x-large
                      rounded
                      to="/transference_govem"
                      @click="timeCheck()"
                      class="action-btn"
                    >
                      <v-icon left>mdi-file-document-edit</v-icon>
                      ยื่นคำร้องขอย้าย
                    </v-btn>
                    
                    <v-btn 
                      icon
                      color="red"
                      @click="VideoDialog()"
                      class="video-btn"
                    >
                      <v-icon>mdi-play-circle</v-icon>
                    </v-btn>
                  </div>
                  
                  <div class="countdown-timer mt-4">
                    <div class="text-center">
                      <p class="deadline-text mb-2">
                        เหลือเวลาอีก
                      </p>
                      <flip-countdown
                        :deadline="periods_govem.period_stop + ' 16:30:00'"
                        :labels="labels"
                      ></flip-countdown>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-hover>

      <!-- แจ้งเตือนย้ายครู -->
      <v-hover v-slot="{ hover }">
        <v-card
          :elevation="hover ? 20 : 4"
          :class="{ 'on-hover': hover }"
          class="alert-card mb-6"
          v-if="periods.period_enable === '1'"
        >
          <div class="alert-stripe success-stripe"></div>
          <v-card-text class="alert-content pa-6">
            <v-row align="center">
              <v-col cols="12" lg="7">
                <div class="alert-header">
                  <v-icon color="green" size="40" class="mr-3">mdi-school</v-icon>
                  <div>
                    <h2 class="alert-title">ข้าราชการครู</h2>
                    <p class="alert-description">
                      สามารถดำเนินการ <strong>ยื่นคำร้องขอย้าย</strong> ก่อนระบบปิดในวันที่
                      <strong class="deadline-text">
                        {{
                          periods.period_stop
                            | moment("add", "543 years")
                            | moment("D MMMM YYYY")
                        }}
                      </strong>
                    </p>
                  </div>
                </div>
              </v-col>
              
              <v-col cols="12" lg="5">
                <div class="alert-actions">
                  <div class="action-buttons" v-if="users.user_status === 'teacher' && users.date_app_now !== ''">
                    <v-btn
                      v-if="
                        periods.period_enable === '1' &&
                          users.user_status === 'teacher' &&
                          periods.period_type === 'teacher' &&
                          !(users.type_personnel === 'local_dev' && get_gov_Age_year < 4)
                      "
                      color="green"
                      x-large
                      rounded
                      to="/transference_personnel"
                      @click="timeCheck()"
                      class="action-btn"
                    >
                      <v-icon left>mdi-file-document-edit</v-icon>
                      ยื่นคำร้องขอย้าย
                    </v-btn>
                    
                    <v-btn 
                      icon
                      color="red"
                      @click="VideoDialog()"
                      class="video-btn"
                    >
                      <v-icon>mdi-play-circle</v-icon>
                    </v-btn>
                  </div>
                  
                  <div class="countdown-timer mt-4">
                    <div class="text-center">
                      <p class="deadline-text mb-2">
                        เหลือเวลาอีก
                      </p>
                      <flip-countdown
                        :deadline="periods.period_stop + ' 16:30:00'"
                        :labels="labels"
                      ></flip-countdown>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-hover>

      <!-- แจ้งเตือนย้าย 38 ค.(2) -->
      <v-hover v-slot="{ hover }">
        <v-card
          :elevation="hover ? 20 : 4"
          :class="{ 'on-hover': hover }"
          class="alert-card mb-6"
          v-if="
            periods_38.period_enable === '1' &&
              (users.user_status == '38' ||
                users.user_status == '3801' ||
                users.user_status == '3802' ||
                users.user_status == '3803')
          "
        >
          <div class="alert-stripe info-stripe"></div>
          <v-card-text class="alert-content pa-6">
            <v-row align="center">
              <v-col cols="12" lg="7">
                <div class="alert-header">
                  <v-icon color="blue" size="40" class="mr-3">mdi-account-multiple</v-icon>
                  <div>
                    <h2 class="alert-title">บุคลากรทางการศึกษาอื่นตามมาตรา 38 ค.(2)</h2>
                    <p class="alert-description">
                      สามารถดำเนินการ <strong>ยื่นคำร้องขอย้าย</strong> ก่อนระบบปิดในวันที่
                      <strong class="deadline-text">
                        {{
                          periods_38.period_stop
                            | moment("add", "543 years")
                            | moment("D MMMM YYYY")
                        }}
                      </strong>
                    </p>
                  </div>
                </div>
              </v-col>
              
              <v-col cols="12" lg="5">
                <div class="alert-actions">
                  <div class="action-buttons" v-if="users.date_app_now !== ''">
                    <v-btn
                      v-if="
                        periods_38.period_enable === '1' &&
                          (users.user_status == '38' ||
                            users.user_status == '3801' ||
                            users.user_status == '3802' ||
                            users.user_status == '3803') &&
                          periods_38.period_type === '38'
                      "
                      color="blue"
                      x-large
                      rounded
                      to="/transference_personnel_38"
                      @click="timeCheck()"
                      class="action-btn"
                    >
                      <v-icon left>mdi-file-document-edit</v-icon>
                      ยื่นคำร้องขอย้าย
                    </v-btn>
                  </div>
                  
                  <div class="countdown-timer mt-4">
                    <div class="text-center">
                      <p class="deadline-text mb-2">
                        เหลือเวลาอีก
                      </p>
                      <flip-countdown
                        :deadline="periods_38.period_stop + ' 16:30:00'"
                        :labels="labels"
                      ></flip-countdown>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-hover>

      <!-- แจ้งเตือนย้าย ผอ -->
      <v-hover v-slot="{ hover }" v-if="users.user_status === 'director'">
        <v-card
          :elevation="hover ? 20 : 4"
          :class="{ 'on-hover': hover }"
          class="alert-card mb-6"
          v-if="periodsmanage_di.period_enable === '1'"
        >
          <div class="alert-stripe urgent-stripe"></div>
          <v-card-text class="alert-content pa-6">
            <v-row align="center">
              <v-col cols="12" lg="7">
                <div class="alert-header">
                  <v-icon color="purple" size="40" class="mr-3">mdi-account-star</v-icon>
                  <div>
                    <h2 class="alert-title">ผู้อำนวยการวิทยาลัย</h2>
                    <p class="alert-description">
                      สามารถดำเนินการ <strong>ยื่นคำร้องขอย้าย</strong>
                      <span v-if="periodsmanage_di.period_normal_case === '1'" class="text-primary">
                        [ กรณีปกติ ]
                      </span>
                      <span v-if="periodsmanage_di.period_quality_case === '1'" class="text-info">
                        [ เพื่อพัฒนาคุณภาพการศึกษา ]
                      </span>
                      ก่อนระบบปิดในวันที่
                      <strong class="deadline-text">
                        {{
                          periodsmanage_di.period_stop
                            | moment("add", "543 years")
                            | moment("D MMMM YYYY")
                        }}
                      </strong>
                    </p>
                    
                    <div class="action-buttons mt-4">
                      <v-btn
                        v-if="periodsmanage_di.period_quality_case === '1'"
                        rounded
                        color="info"
                        dark
                        class="ma-1 action-btn"
                        to="/transference_manage_d"
                      >
                        <v-icon left>mdi-school</v-icon>
                        การย้ายสายงานบริหารสถานศึกษา
                        <span class="red--text ml-2 font-weight-bold">
                          (เพื่อพัฒนาคุณภาพการศึกษา)
                        </span>
                      </v-btn>

                      <v-btn
                        v-if="periodsmanage_di.period_normal_case === '1'"
                        rounded
                        color="primary"
                        dark
                        to="/transference_manage"
                        class="ma-1 action-btn"
                      >
                        <v-icon left>mdi-file-document-edit</v-icon>
                        การย้ายสายงานบริหารสถานศึกษา (กรณีปกติ)
                      </v-btn>
                    </div>
                  </div>
                </div>
              </v-col>
              
              <v-col cols="12" lg="5">
                <div class="alert-actions">
                  <div class="countdown-timer">
                    <div class="text-center">
                      <p class="deadline-text mb-2">
                        เหลือเวลาอีก
                      </p>
                      <flip-countdown
                        :deadline="periodsmanage_di.period_stop + ' 16:30:00'"
                        :labels="labels"
                      ></flip-countdown>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-hover>

      <!-- แจ้งเตือนย้าย รอง -->
      <v-hover v-slot="{ hover }" v-if="users.user_status === 'se_director'">
        <v-card
          :elevation="hover ? 20 : 4"
          :class="{ 'on-hover': hover }"
          class="alert-card mb-6"
          v-if="periodsmanage_sedi.period_enable === '1'"
        >
          <div class="alert-stripe warning-stripe"></div>
          <v-card-text class="alert-content pa-6">
            <v-row align="center">
              <v-col cols="12" lg="7">
                <div class="alert-header">
                  <v-icon color="orange" size="40" class="mr-3">mdi-account-tie</v-icon>
                  <div>
                    <h2 class="alert-title">รองผู้อำนวยการวิทยาลัย</h2>
                    <p class="alert-description">
                      สามารถดำเนินการ <strong>ยื่นคำร้องขอย้าย</strong> ก่อนระบบปิดในวันที่
                      <strong class="deadline-text">
                        {{
                          periodsmanage_sedi.period_stop
                            | moment("add", "543 years")
                            | moment("D MMMM YYYY")
                        }}
                      </strong>
                    </p>
                  </div>
                </div>
              </v-col>
              
              <v-col cols="12" lg="5">
                <div class="alert-actions">
                  <div class="countdown-timer">
                    <div class="text-center">
                      <p class="deadline-text mb-2">
                        เหลือเวลาอีก
                      </p>
                      <flip-countdown
                        :deadline="periodsmanage_sedi.period_stop + ' 16:30:00'"
                        :labels="labels"
                      ></flip-countdown>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-hover>
    </div>

    

    <!-- Active Applications Dialog -->
    <v-dialog v-model="activeApplicationsDialog" max-width="900px">
      <v-card>
        <v-card-title class="flex-between">
          <div>
            <v-icon color="primary" class="mr-2">mdi-account-clock</v-icon>
            <span class="headline">การสมัครที่เปิดอยู่</span>
          </div>
          <v-btn icon @click="activeApplicationsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item
              v-for="(app, index) in activeApplications"
              :key="index"
              class="mb-2"
            >
              <v-list-item-avatar>
                <v-icon :color="app.color" size="30">{{ app.icon }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">
                  {{ app.title }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ app.description }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="deadline-text mt-1">
                  <v-icon small color="error" class="mr-1">mdi-clock-outline</v-icon>
                  ปิดรับสมัคร: {{ app.deadline | moment("add", "543 years") | moment("D MMMM YYYY") }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn 
                  :color="app.color" 
                  outlined 
                  rounded 
                  small 
                  :to="app.route"
                  v-if="app.canApply"
                >
                  <v-icon left small>mdi-account-plus</v-icon>
                  สมัคร
                </v-btn>
                <v-chip v-else color="grey" text-color="white" small>
                  ไม่สามารถสมัครได้
                </v-chip>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-alert v-if="activeApplications.length === 0" type="info" outlined>
            <div class="text-center">
              <v-icon size="48" color="info">mdi-information-outline</v-icon>
              <h3 class="mt-2">ไม่มีการสมัครที่เปิดอยู่ในขณะนี้</h3>
              <p>โปรดติดตามประกาศการรับสมัครในช่วงเวลาถัดไป</p>
            </div>
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Urgent Deadlines Dialog -->
    <v-dialog v-model="urgentDeadlinesDialog" max-width="900px">
      <v-card>
        <v-card-title class="flex-between">
          <div>
            <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
            <span class="headline">ใกล้ปิดรับสมัคร (ภายใน 7 วัน)</span>
          </div>
          <v-btn icon @click="urgentDeadlinesDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item
              v-for="(app, index) in urgentDeadlinesList"
              :key="index"
              class="mb-2"
            >
              <v-list-item-avatar>
                <v-icon color="error" size="30">{{ app.icon }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">
                  {{ app.title }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ app.description }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="deadline-text mt-1">
                  <v-icon small color="error" class="mr-1">mdi-timer-sand</v-icon>
                  เหลือเวลา: {{ app.daysLeft }} วัน
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <div class="text-center">
                  <v-btn 
                    color="error" 
                    rounded 
                    small 
                    :to="app.route"
                    v-if="app.canApply"
                    class="mb-1"
                  >
                    <v-icon left small>mdi-rocket-launch</v-icon>
                    สมัครด่วน
                  </v-btn>
                  <div class="countdown-mini">
                    <flip-countdown
                      :deadline="app.deadline + ' 16:30:00'"
                      :labels="miniLabels"
                    ></flip-countdown>
                  </div>
                </div>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-alert v-if="urgentDeadlinesList.length === 0" type="success" outlined>
            <div class="text-center">
              <v-icon size="48" color="success">mdi-check-circle-outline</v-icon>
              <h3 class="mt-2">ไม่มีการสมัครที่ใกล้ปิดในขณะนี้</h3>
              <p>ระบบทั้งหมดยังมีเวลาเหลือมากกว่า 7 วัน</p>
            </div>
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Video Dialog -->
    <v-dialog v-model="VideoDialogYoutube" max-width="800px">
      <v-card>
        <v-card-title class="flex-between">
          <span class="headline">วิดีโอแนะนำ</span>
          <v-btn icon @click="VideoDialogYoutubeStop()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="video-container">
            <p class="text-center text-muted">
              เนื้อหาวิดีโอจะแสดงที่นี่
            </p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Loading Overlay -->
    <div v-if="loading" class="loading-overlay">
      <div class="loading-spinner"></div>
    </div>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
    >
      <v-icon v-if="snackbar.icon" left>{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import FlipCountdown from "vue2-flip-countdown";

export default {
  components: { FlipCountdown },
  name: "ModernAlertDashboard",
  
  data() {
    return {
      loading: false,
      VideoDialogYoutube: false,
      ApiKey: "HRvec2021",
      user: {},
      users: [],
      users_etc: [],
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      periods: [],
      periods_38: [],
      periods_govem: [],
      periodsmanage_sedi: [],
      periodsmanage_di: [],
      period_sedirectors: [],
      period_directors: [],
      period_directorsprocess: [],
      period_sedirectorsprocess: [],
      director_apps: [],
      sedirector_apps: [],
      checksedirector_app_idrefs: [],
      transference_personnels: [],
      manage_assistant_teachers: [],
      sedirector_app_idcards: [],
      provices_sh: [],
      prefectures: [],
      district: [],
      labels: {
        days: "วัน",
        hours: "ชั่วโมง",
        minutes: "นาที",
        seconds: "วินาที"
      },
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      imageFiles: null,
      license_file: null,
      license_filedr: null,
      pt_licence_file_tem: null,
      pdflicenseteachdialog: false,
      pdflicensedrdialog: false,
      licensefiles: "",
      permitdialog: false,
      passwoorddialog: false,
      addpersonneldialog: false,
      personnel_temporary_pic_dialog: false,
      deletefiledialog: false,
      show1: false,
      dateNows: null,
      dateStops: null,
      date_month_cal: new Date().toISOString().substr(0, 10),
      activeApplicationsDialog: false,
      urgentDeadlinesDialog: false,
      miniLabels: {
        days: "วัน",
        hours: "ชม.",
        minutes: "นาที",
        seconds: "วิ"
      },
      periodTeacherAssistant:[],
    };
  },

  computed: {
    activeApplications() {
      const applications = [];
      
      // ผู้อำนวยการ
      if (this.period_directors.period_sedirector_enable === '1' &&
          (this.users.user_status === 'se_director' ||
           this.users.user_status === 'teacher' ||
           this.users.user_status === 'S' ||
           this.users.user_status === 'C')) {
        applications.push({
          title: 'ผู้อำนวยการวิทยาลัย',
          description: 'การรับสมัครคัดเลือกตำแหน่งผู้อำนวยการวิทยาลัย',
          deadline: this.period_directors.period_sedirector_stop,
          route: '/director_app',
          icon: 'mdi-account-star',
          color: 'primary',
          canApply: true
        });
      }

      // รองผู้อำนวยการ
      if (this.period_sedirectors.period_sedirector_enable === '1' &&
          (this.users.user_status === 'teacher' || this.users.user_status === 'S')) {
        applications.push({
          title: 'รองผู้อำนวยการวิทยาลัย',
          description: 'การรับสมัครตำแหน่งรองผู้อำนวยการวิทยาลัย',
          deadline: this.period_sedirectors.period_sedirector_stop,
          route: '/sedirector_app',
          icon: 'mdi-account-tie',
          color: 'info',
          canApply: true
        });
      }

      // พนักงานราชการ
      if (this.periods_govem.period_enable === '1' && this.users.user_status === 'gov_em') {
        applications.push({
          title: 'การย้ายพนักงานราชการ',
          description: 'ยื่นคำร้องขอย้ายสำหรับพนักงานราชการ',
          deadline: this.periods_govem.period_stop,
          route: '/transference_govem',
          icon: 'mdi-account-group',
          color: 'orange',
          canApply: this.users.date_app_now !== '' && !(this.users.type_personnel === 'gov_em' && this.get_gov_Age_year < 1)
        });
      }

      // ข้าราชการครู
      if (this.periods.period_enable === '1') {
        applications.push({
          title: 'การย้ายข้าราชการครู',
          description: 'ยื่นคำร้องขอย้ายสำหรับข้าราชการครู',
          deadline: this.periods.period_stop,
          route: '/transference_personnel',
          icon: 'mdi-school',
          color: 'green',
          canApply: this.users.user_status === 'teacher' && this.users.date_app_now !== '' && 
                   !(this.users.type_personnel === 'local_dev' && this.get_gov_Age_year < 4)
        });
      }

      // บุคลากรมาตรา 38
      if (this.periods_38.period_enable === '1' &&
          (this.users.user_status == '38' ||
           this.users.user_status == '3801' ||
           this.users.user_status == '3802' ||
           this.users.user_status == '3803')) {
        applications.push({
          title: 'บุคลากรทางการศึกษาอื่นตามมาตรา 38 ค.(2)',
          description: 'ยื่นคำร้องขอย้ายสำหรับบุคลากรมาตรา 38',
          deadline: this.periods_38.period_stop,
          route: '/transference_personnel_38',
          icon: 'mdi-account-multiple',
          color: 'blue',
          canApply: this.users.date_app_now !== ''
        });
      }

      // การย้ายผู้อำนวยการ
      if (this.periodsmanage_di.period_enable === '1' && this.users.user_status === 'director') {
        applications.push({
          title: 'การย้ายผู้อำนวยการวิทยาลัย',
          description: 'ยื่นคำร้องขอย้ายสำหรับผู้อำนวยการ (กรณีปกติ/พัฒนาคุณภาพ)',
          deadline: this.periodsmanage_di.period_stop,
          route: '/transference_manage',
          icon: 'mdi-account-star',
          color: 'purple',
          canApply: true
        });
      }

      // การย้ายรองผู้อำนวยการ
      if (this.periodsmanage_sedi.period_enable === '1' && this.users.user_status === 'se_director') {
        applications.push({
          title: 'การย้ายรองผู้อำนวยการวิทยาลัย',
          description: 'ยื่นคำร้องขอย้ายสำหรับรองผู้อำนวยการ',
          deadline: this.periodsmanage_sedi.period_stop,
          route: '/transference_manage_se',
          icon: 'mdi-account-tie',
          color: 'orange',
          canApply: true
        });
      }

      return applications;
    },

    urgentDeadlinesList() {
      const urgent = [];
      const today = new Date();
      const urgentThreshold = 7 * 24 * 60 * 60 * 1000; // 7 days in milliseconds

      this.activeApplications.forEach(app => {
        if (app.deadline) {
          const deadline = new Date(app.deadline);
          const timeLeft = deadline - today;
          const daysLeft = Math.ceil(timeLeft / (24 * 60 * 60 * 1000));
          
          if (timeLeft <= urgentThreshold && timeLeft > 0) {
            urgent.push({
              ...app,
              daysLeft: daysLeft
            });
          }
        }
      });

      return urgent.sort((a, b) => a.daysLeft - b.daysLeft);
    },

    urgentDeadlines() {
      return this.urgentDeadlinesList.length;
    },

    approvedApplications() {
      let count = 0;
      if (this.director_apps.sedirector_app_pvc_approve === 'pass') count++;
      if (this.director_apps.sedirector_app_ipacheck === 'pass') count++;
      return count;
    },

    pendingApplications() {
      let count = 0;
      if (this.director_apps.sedirector_app_ipacheck === 'notpass') count++;
      // เพิ่มเงื่อนไขอื่นๆ สำหรับสถานะรอการตรวจสอบ
      return count;
    },

    get_gov_Age_year() {
      if (!this.users.date_app_now) return 0;
      
      const today = new Date();
      const startDate = new Date(this.users.date_app_now);
      const years = today.getFullYear() - startDate.getFullYear();
      
      if (startDate.getMonth() > today.getMonth() || 
          (startDate.getMonth() === today.getMonth() && startDate.getDate() > today.getDate())) {
        return years - 1;
      }
      return years;
    }
  },

  methods: {
    // ======= Original API Methods =======
    async manage_assistant_teacherQuery() {
      if (this.users.position_name == "ครูผู้ช่วย") {
        let result = await this.$http.post("manage_assistant_teacher.php", {
          ApiKey: this.ApiKey,
          mt_id_card: this.users.id_card,
          flash: "ok"
        });
        this.manage_assistant_teachers = result.data;
      }
    },

    async sedirector_app_idcardQuery() {
      let result = await this.$http.post("sedirector_app.php", {
        ApiKey: this.ApiKey,
        sedirector_app_idcard: this.users.id_card
      });
      this.sedirector_app_idcards = result.data;
    },

    async personnelQuery() {
      this.loading = true;
      let useression = JSON.parse(sessionStorage.getItem("user")) || 0;
      let result = await this.$http
        .post("personnel_temporary.php", {
          ApiKey: this.ApiKey,
          id_card: useression.id_card
        })
        .finally(() => (this.loading = false));
      this.users = result.data;
    },

    async personnel_etcQuery() {
      this.loading = true;
      let useression = JSON.parse(sessionStorage.getItem("user")) || 0;
      let result = await this.$http
        .post("personnel_etc.php", {
          ApiKey: this.ApiKey,
          personnel_etc_id_card: useression.id_card
        })
        .finally(() => (this.loading = false));
      this.users_etc = result.data;
    },

    async date_app_nowCheck() {
      let datecheck = String(this.users.date_app_now);
      if (datecheck.length < 5) {
        Swal.fire({
          icon: "error",
          title: "ให้ งานบุคลากร ดำเนินการปรับปรุงวันที่ปฏิบัติงานของท่านให้เรียบร้อย"
        });
      }
    },

    async periodManagedirectorQuery() {
      let result_period;
      result_period = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_id: "101"
      });
      this.periodsmanage_di = result_period.data;
    },


     async periodTeacherAssistantQuery() {
      let result_period;
      result_period = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_id: "30101"
      });
      this.periodTeacherAssistant = result_period.data;
    },



    async periodManageSedirectorQuery() {
      let result_period;
      result_period = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_id: "201"
      });
      this.periodsmanage_sedi = result_period.data;
    },

    async periodQuery() {
      let result_period;
      result_period = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_id: "301"
      });
      this.periods = result_period.data;
    },

    async periodGov_emQuery() {
      let result_period;
      result_period = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_id: "401"
      });
      this.periods_govem = result_period.data;
    },

    async period38Query() {
      let result_period;
      result_period = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_id: "3801"
      });
      this.periods_38 = result_period.data;
    },

    async period_sedirectorQuery() {
      let result_period;
      result_period = await this.$http.post("period_sedirector.php", {
        ApiKey: this.ApiKey,
        period_sedirector_enable: "1",
        period_sedirector_id: "201"
      });
      this.period_sedirectors = result_period.data;
    },

    async period_directorQuery() {
      let result_period;
      result_period = await this.$http.post("period_sedirector.php", {
        ApiKey: this.ApiKey,
        period_sedirector_enable: "1",
        period_sedirector_id: "301"
      });
      this.period_directors = result_period.data;
    },

    async period_directorProcess() {
      let result_period;
      result_period = await this.$http.post("period_sedirector.php", {
        ApiKey: this.ApiKey,
        period_sedirector_process: "1",
        period_sedirector_id: "301"
      });
      this.period_directorsprocess = result_period.data;

      let result = await this.$http.post("sedirector_app.php", {
        ApiKey: this.ApiKey,
        sedirector_app_year: this.period_directorsprocess.period_sedirector_year,
        sedirector_app_time: this.period_directorsprocess.period_sedirector_times,
        sedirector_app_idcard: this.users.id_card,
        sedirector_app_ptype: 3
      });
      this.director_apps = result.data;
      let checkdata = String(this.director_apps.sedirector_app_idref);
      if (checkdata.length > 10) {
        this.checksedirector_app_idrefs = "true";
      } else {
        this.checksedirector_app_idrefs = "false";
      }
    },

    async period_sedirectorProcess() {
      let result_period;
      result_period = await this.$http.post("period_sedirector.php", {
        ApiKey: this.ApiKey,
        period_sedirector_process: "1",
        period_sedirector_id: "201"
      });
      this.period_sedirectorsprocess = result_period.data;

      let result = await this.$http.post("sedirector_app.php", {
        ApiKey: this.ApiKey,
        sedirector_app_year: this.period_sedirectorsprocess.period_sedirector_year,
        sedirector_app_time: this.period_sedirectorsprocess.period_sedirector_times,
        sedirector_app_idcard: this.users.id_card
      });
      this.sedirector_apps = result.data;
      let checkdata = String(this.sedirector_apps.sedirector_app_idref);
      if (checkdata.length > 10) {
        this.checksedirector_app_idrefs = "true";
      } else {
        this.checksedirector_app_idrefs = "false";
      }
    },

    async transference_personnelQueryAll() {
      let result;
      if (
        this.users.user_status === "teacher" ||
        this.users.user_status === "gov_em"
      ) {
        result = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          id_card: this.users.id_card
        });
        this.transference_personnels = result.data;
      } else if (
        this.users.user_status === "director" ||
        this.users.user_status === "se_director"
      ) {
        result = await this.$http.post("transference_manage.php", {
          ApiKey: this.ApiKey,
          manage_id_card: this.users.id_card
        });
        this.transference_personnels = result.data;
      } else if (this.users.user_status === "S") {
        // Handle S status
      } else if (
        this.users.user_status === "38" ||
        this.users.user_status === "3801" ||
        this.users.user_status === "3802" ||
        this.users.user_status === "38030"
      ) {
        let result38 = await this.$http.post("transference_personnel_38.php", {
          ApiKey: this.ApiKey,
          tp_id_card: this.users.id_card
        });
        this.transference_personnels = result38.data;
      }
    },

    // ======= Time and Period Management =======
    async timeCheck() {
      const dateNow = new Date();
      const dateStop = new Date(this.periods.period_stop + " 16:30:00");
      this.dateNows = dateNow.getTime();
      this.dateStops = dateStop.getTime();
      
      if (this.dateNows > this.dateStops) {
        await this.periodTeacherUpdate();
      }
    },

    async periodTeacherUpdate() {
      try {
        this.periods.ApiKey = this.ApiKey;
        this.periods.period_enable = "0";
        await this.$http.post("period.update.php", this.periods);
      } catch (error) {
        this.showSnackbar('เกิดข้อผิดพลาดในการอัพเดทระบบ', 'error', 'mdi-alert-circle');
      }
    },

    // ======= File and Document Management =======
    async viewpdflicenseteach(licensefile) {
      this.licensefiles = "";
      this.licensefiles = licensefile;
      this.pdflicenseteachdialog = true;
    },

    async viewpdflicensedr() {
      this.pdflicensedrdialog = true;
    },

    async deletelicensedr() {
      Swal.fire({
        title: "ยืนยันการลบ",
        text: "ลบไฟล์ใบอนุญาตประกอบวิชาชีพผู้บริหารเดิม",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.isConfirmed) {
          let result = await this.$http.post("deletefile.php", {
            ApiKey: this.ApiKey,
            filename: "../HRvecLicenseDirector/" + this.users.pt_licencedr_file
          });

          result = await this.$http.post("personnel_temporary.update.php", {
            ApiKey: this.ApiKey,
            pt_licencedr_file: "",
            id_card: this.users.id_card
          });

          if (result.data.status == true) {
            Swal.fire({
              icon: "success",
              title: "ดำเนินการลบข้อมูลเรียบร้อย",
              showConfirmButton: false,
              timer: 1500
            });
            this.personnelQuery();
          } else {
            Swal.fire({
              icon: "warning",
              title: "ดำเนินการลบผิดพลาด",
              showConfirmButton: false,
              timer: 1500
            });
          }
        }
      });
    },

    async deletelicenseteach() {
      Swal.fire({
        title: "ยืนยันการลบ",
        text: "ลบไฟล์ใบอนุญาตประกอบวิชาชีพครู เดิม",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.isConfirmed) {
          let result = await this.$http.post("deletefile.php", {
            ApiKey: this.ApiKey,
            filename: "../HRvecLicenseTeach/" + this.users.pt_licence_file
          });

          let resultup = await this.$http.post("personnel_temporary.update.php", {
            ApiKey: this.ApiKey,
            pt_licence_file: "",
            id_card: this.users.id_card
          });

          if (resultup.data.status == true) {
            Swal.fire({
              icon: "success",
              title: "ดำเนินการลบข้อมูลเรียบร้อย",
              showConfirmButton: false,
              timer: 1500
            });
            this.personnelQuery();
          } else {
            Swal.fire({
              icon: "warning",
              title: "ดำเนินการลบผิดพลาด",
              showConfirmButton: false,
              timer: 1500
            });
          }
        }
      });
    },

    // ======= Form Submissions =======
    async personnelSubmit() {
      if (this.$refs.personnelform.validate()) {
        this.users.ApiKey = this.ApiKey;
        let uploaded = null;
        
        if (this.license_file != null) {
          let formData = new FormData();
          let filename = this.users.id_card + "" + this.time_stamp + "" + "teach.pdf";
          formData.append("ApiKey", this.ApiKey);
          formData.append("file", this.license_file);
          formData.append("filename", "../HRvecLicenseTeach/" + filename);
          
          let result = await this.$http.post("uploadfile.php", formData, {
            headers: { "Content-Type": "multipart/form-data" }
          });
          this.users.pt_licence_file = filename;
          uploaded = true;
        }

        if (this.license_filedr != null) {
          let formData = new FormData();
          let filename = this.users.id_card + "" + this.time_stamp + "" + "dr.pdf";
          formData.append("ApiKey", this.ApiKey);
          formData.append("file", this.license_filedr);
          formData.append("filename", "../HRvecLicenseDirector/" + filename);
          
          let result = await this.$http.post("uploadfile.php", formData, {
            headers: { "Content-Type": "multipart/form-data" }
          });
          this.users.pt_licencedr_file = filename;
          uploaded = true;
        }

        let result = await this.$http.post("personnel_temporary.update.php", this.users);
        let result_m = await this.$http.post("personnel_marriage.insert.php", this.users);

        if (result.data.status == true || result_m.data.status == true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการแก้ไขข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.personnelQuery();
        }
      }
    },

    async passwordSubmit() {
      if (this.$refs.passwordform.validate()) {
        this.users.ApiKey = this.ApiKey;
        let result = await this.$http.post("personnel_temporary.update.password.php", this.users);
        
        if (result.data.status == true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการแก้ไขข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.personnelQuery();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
      }
      this.passwoorddialog = false;
    },

    // ======= Location Queries =======
    async prefectureQueryAll(province_ID) {
      let result = await this.$http.post("prefecture.php", {
        province_ID: province_ID
      });
      this.prefectures = result.data;
    },

    async districtQueryAll(prefecture_ID) {
      let result = await this.$http.post("districts.php", {
        prefecture_ID: prefecture_ID
      });
      this.district = result.data;
    },

    // ======= UI Control Methods =======
    async VideoDialog() {
      this.VideoDialogYoutube = true;
    },

    async VideoDialogYoutubeStop() {
      const videos = document.querySelectorAll("iframe, video");
      Array.prototype.forEach.call(videos, function(video) {
        if (video.tagName.toLowerCase() === "video") {
          video.pause();
        } else {
          const src = video.src;
          video.src = src;
        }
      });
      this.VideoDialogYoutube = false;
    },

    showSnackbar(text, color = 'info', icon = 'mdi-information') {
      this.snackbar = {
        show: true,
        text,
        color,
        icon,
        timeout: 5000
      };
    }
  },

  async mounted() {
    await this.periodTeacherAssistantQuery()
    await this.personnelQuery();
    await this.personnel_etcQuery();
    await this.date_app_nowCheck();
    await this.periodQuery();
    await this.periodGov_emQuery();
    await this.periodManagedirectorQuery();
    await this.periodManageSedirectorQuery();
    await this.timeCheck();
    await this.period_sedirectorQuery();
    await this.period_sedirectorProcess();
    await this.transference_personnelQueryAll();
    await this.sedirector_app_idcardQuery();
    await this.period_directorQuery();
    await this.period_directorProcess();
    await this.period38Query();
    await this.manage_assistant_teacherQuery();
  }
};
</script>

<style scoped>
/* Dashboard Styles */
.alert-dashboard {
  background: #f5f7fa;
  min-height: 100vh;
}

/* Header Section */
.dashboard-header {
  border-radius: 10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.header-content {
  text-align: center;
  color: white;
}

.dashboard-title {
  font-size: 2.5rem;
  font-weight: 700;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.dashboard-subtitle {
  font-size: 1.2rem;
  opacity: 0.9;
  font-weight: 300;
}

/* Summary Cards */
.summary-card {
  border-radius: 15px !important;
  transition: all 0.3s ease;
  border-left: 5px solid;
  height: 120px;
}

.summary-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2) !important;
}

.active-card {
  border-left-color: #2196f3;
}
.urgent-card {
  border-left-color: #f44336;
}
.completed-card {
  border-left-color: #4caf50;
}
.pending-card {
  border-left-color: #ff9800;
}

.summary-content {
  display: flex;
  align-items: center;
  height: 100%;
}

.summary-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  flex-shrink: 0;
}

.active-icon {
  background: linear-gradient(45deg, #2196f3, #21cbf3);
}
.urgent-icon {
  background: linear-gradient(45deg, #f44336, #e91e63);
}
.completed-icon {
  background: linear-gradient(45deg, #4caf50, #8bc34a);
}
.pending-icon {
  background: linear-gradient(45deg, #ff9800, #ffc107);
}

.summary-info {
  flex: 1;
}

.summary-title {
  font-size: 0.9rem;
  color: #666;
  font-weight: 500;
  
}

.summary-value {
  font-size: 2rem;
  font-weight: bold;
  color: #2c3e50;
  
}

/* Alert Cards */
.alert-card {
  border-radius: 15px !important;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.alert-card:hover {
  transform: translateY(-3px);
}

.alert-card.on-hover {
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15) !important;
}

.alert-stripe {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 6px;
}

.urgent-stripe {
  background: linear-gradient(to bottom, #f44336, #e91e63);
  animation: pulse 2s infinite;
}
.warning-stripe {
  background: linear-gradient(to bottom, #ff9800, #ffc107);
}
.error-stripe {
  background: linear-gradient(to bottom, #f44336, #d32f2f);
}
.success-stripe {
  background: linear-gradient(to bottom, #4caf50, #8bc34a);
}
.info-stripe {
  background: linear-gradient(to bottom, #2196f3, #21cbf3);
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}

.alert-content {
  padding-left: 10px;
}

.alert-header {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
}

.alert-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #2c3e50;
  
  line-height: 1.3;
}

.alert-description {
  font-size: 1rem;
  color: #666;
  line-height: 1.4;
  
}

.deadline-text {
  font-size: 0.95rem;
  color: #f44336;
  font-weight: 500;
}

.alert-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 15px;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.countdown-timer {
  margin-bottom: 10px;
}

.action-btn {
  border-radius: 10px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
  min-width: 140px;
}

.action-btn:hover {
  transform: translateY(-2px);
}

.video-btn {
  border-radius: 50% !important;
  min-width: 40px !important;
  width: 40px !important;
  height: 40px !important;
}

/* Status Cards */
.status-card {
  border-radius: 10px !important;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.status-card:hover {
  transform: translateX(5px);
}

/* Countdown Timer Styles */
.countdown-timer >>> .flip-countdown {
  font-family: "Roboto", sans-serif;
}

.countdown-timer >>> .flip-countdown__piece {
  background: #2c3e50;
  color: white;
  border-radius: 5px;
  font-size: 0.9rem;
  min-width: 35px;
  height: 35px;
}

.countdown-timer >>> .flip-countdown__slot {
  font-size: 0.7rem;
  color: #666;
  margin-top: 5px;
}

/* Video Dialog */
.video-container {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 10px;
}

/* Loading state */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Utility classes */
.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.text-muted {
  color: #666 !important;
}

.text-primary {
  color: #2196f3 !important;
}

.text-success {
  color: #4caf50 !important;
}

.text-warning {
  color: #ff9800 !important;
}

.text-error {
  color: #f44336 !important;
}

.text-info {
  color: #2196f3 !important;
}

/* Animation Effects */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.alert-card {
  animation: fadeInUp 0.6s ease-out;
}

.summary-card {
  animation: fadeInUp 0.6s ease-out;
}

.summary-card:nth-child(1) {
  animation-delay: 0.1s;
}
.summary-card:nth-child(2) {
  animation-delay: 0.2s;
}
.summary-card:nth-child(3) {
  animation-delay: 0.3s;
}
.summary-card:nth-child(4) {
  animation-delay: 0.4s;
}

/* Responsive Design */
@media (max-width: 768px) {
  .dashboard-title {
    font-size: 2rem;
  }

  .dashboard-subtitle {
    font-size: 1rem;
  }

  .alert-title {
    font-size: 1.2rem;
  }

  .alert-description {
    font-size: 0.9rem;
  }

  .summary-value {
    font-size: 1.6rem;
  }

  .summary-icon {
    width: 50px;
    height: 50px;
    margin-right: 15px;
  }

  .alert-actions {
    margin-top: 20px;
  }

  .countdown-timer >>> .flip-countdown__piece {
    min-width: 30px;
    height: 30px;
    font-size: 0.8rem;
  }
}

@media (max-width: 600px) {
  .alert-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .alert-header .v-icon {
    margin-bottom: 10px;
  }

  .summary-content {
    flex-direction: column;
    text-align: center;
  }

  .summary-icon {
    margin-right: 0;
    margin-bottom: 10px;
  }
}

/* Vue transitions */
.v-application {
  font-family: "Sarabun", "Roboto", sans-serif !important;
}

.v-btn {
  text-transform: none !important;
  font-weight: 500 !important;
}

.v-card {
  transition: all 0.3s ease !important;
}

/* Focus states for accessibility */
.action-btn:focus {
  outline: 2px solid #667eea;
  outline-offset: 2px;
}

.alert-card:focus-within {
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.3);
}
</style>